import Helper from '@ember/component/helper';
import { type Registry as Services, service } from '@ember/service';
import type { FeatureToggle } from 'lumen/utils/constants/feature-toggle-constants';

interface HasFeatureToggleSignature {
  Args: {
    Positional: [FeatureToggle];
  };
  Return: boolean;
}

export default class HasFeatureToggleHelper extends Helper<HasFeatureToggleSignature> {
  @service declare featureToggle: Services['feature-toggle'];

  compute([
    featureToggle,
  ]: HasFeatureToggleSignature['Args']['Positional']): HasFeatureToggleSignature['Return'] {
    return this.featureToggle.hasFeatureToggle(featureToggle);
  }
}
